import { SnapshotBase, TrackID } from "@/shared/types";
import { ObservableObject } from "@legendapp/state";

export type TrackWithSnapshots<TSnapshot extends SnapshotBase> = {
  track_id: TrackID;
  snapshots: TSnapshot[];
};

export abstract class TrackSourceBuffer<
  TSnapshot extends SnapshotBase,
  TBuffer = unknown,
> {
  protected abstract buffer: ObservableObject<TBuffer>; // Buffer to store the received objects
  protected startTime: Date | null = null;
  protected startTimeAnchor: Date | null = null;

  public setStartTime(startTime: Date, skipOverride = false) {
    if (this.startTime && skipOverride) return;

    this.startTime = startTime;
    this.startTimeAnchor = new Date(startTime);
    this.startTimeAnchor.setMilliseconds(0);
  }

  public getInternalBuffer() {
    return this.buffer;
  }

  public getKeys(): string[] {
    /**
     * Retrieve the track ids from the buffer.
     * Object keys is a shallow listener.
     */
    return Object.keys(this.buffer);
  }

  abstract appendBuffer(tracks: TrackWithSnapshots<TSnapshot>[]): void;
  abstract findSnapshot(key: string, datetime: number): TSnapshot | null;
  abstract flushBuffer(
    durationInSec: number,
    currentTime: number,
    onFlush?: () => void
  ): void;
  abstract clear(): void;
}
